import React from 'react';
import {useFormContext} from 'react-hook-form';
import {FormBlock, FormBlockFieldOther} from 'api';

interface Block extends FormBlock {
  formBlockable: FormBlockFieldOther;
}

interface Props {
  block: Block;
}

export default ({block}: Props) => {
  const blockable = block.formBlockable;
  const {
    register,
    formState: {errors = {}},
  } = useFormContext();
  const error: any = errors[block.id];
  const errorMessage = error?.message;

  return (
    <div className="w-full">
      <div className="flex gap-1 mb-2 items-center">
        <label className="tracking-wide font-bold">{blockable.title}</label>
        {blockable.isRequired && <span className="text-red-500">*</span>}
      </div>
      <textarea
        className="form-textarea h-32 block w-full border rounded placeholder-c-lighter"
        placeholder={blockable.placeholder}
        {...register(block.id)}
      />
      {errorMessage && <div className="text-red-500">{errorMessage}</div>}
      {blockable.helpText && (
        <div className="text-c-light text-sm whitespace-pre-wrap">
          {blockable.helpText}
        </div>
      )}
    </div>
  );
};
